import { Component } from '@angular/core';
import { MainFilterClass } from '../main-filter';

@Component({
  selector: 'app-number-filter',
  templateUrl: './number-filter.component.html',
  styleUrls: ['./number-filter.component.less'],
})
export class NumberFilterComponent extends MainFilterClass {
  firstValue: any;
  secondValue: any;
  override onChange(value: any): void {
    if ([6, 7].includes(this.operator.operator)) {
      if (this.firstValue == null || this.secondValue == null) {
        this.errorMessage = 'Both inputs must have values';
        this.hasError = true;
        this.onModelChange.emit(null);
        return;
      }
      this.hasError = false;

      this.value = `${this.firstValue};${this.secondValue}`;
    } else {
      this.value = value;
    }
    this.onModelChange.emit(this.value);
  }
}
